import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
// import { Link } from "react-router-dom";

const Industries = () => {
  const industries = [
    {
      icon: (
        <img src="/assets/Group.svg" alt="Industry 1" className="img-fluid" />
      ),
      title: "Healthcare",
    },
    {
      icon: (
        <img
          src="/assets/octicon_law-16.svg"
          alt="Industry 2"
          className="img-fluid"
        />
      ),
      title: "Law Firms",
    },
    {
      icon: (
        <img src="/assets/home.svg" alt="Industry 3" className="img-fluid" />
      ),
      title: "Home Services",
    },
    {
      icon: (
        <img
          src="/assets/nimbus_marketing.svg"
          alt="Industry 4"
          className="img-fluid"
        />
      ),
      title: "Marketing Agencies",
    },
  ];

  const description = "Manages Appointment";
  const descriptionIcon = (
    <img
      src="/assets/calendar-sm.svg"
      alt="Description Icon"
      className="img-fluid"
    />
  );
  const additionalInfo =
    "Connects to your calendar to book and change appointments.";
  const description2 = "Instant Answering";
  const descriptionIcon2 = (
    <img
      src="/assets/phone-call-sm.svg"
      alt="Support Icon"
      className="img-fluid"
    />
  );
  const additionalInfo2 =
    "Runs day and night to ensure every call is answered instantly";
  const description3 = "Answers questions";
  const descriptionIcon3 = (
    <img src="/assets/globe.svg" alt="Security Icon" className="img-fluid" />
  );
  const additionalInfo3 =
    "Answers business specific questions from parking to pricing";

  return (
    <div className="container-fluid body-font empty-space-mt">
      <Container>
        <h1 className="text-center  fw-bold fs-four-title anybody-font my-5">
          Customize it for Your Business
        </h1>
        <Row>
          {industries.map((industry, index) => (
            <Col md={3} className="mb-4" key={index}>
              <Card className="h-100 py-4 shadow border-0">
                <Card.Body className="d-flex flex-column align-items-start ps-lg-4">
                  <div className="d-flex align-items-center w-100">
                    <div className="icon-container me-3">{industry.icon}</div>
                    <Card.Title className="fs-three-title fw-bold mb-0 anybody-font">
                      {industry.title}
                    </Card.Title>
                  </div>
                  <hr className="border-dark-subtle w-100" />
                  <div className="d-flex align-items-center w-100">
                    <Card.Text className="mt-2 d-flex align-items-center fw-bold gap-3 fs-three">
                      {descriptionIcon}
                      {description}
                    </Card.Text>
                  </div>
                  <Card.Text className="mt-2">{additionalInfo}</Card.Text>
                  <div className="d-flex align-items-center w-100">
                    <Card.Text className="mt-3 d-flex align-items-center fw-bold gap-3 fs-three">
                      {descriptionIcon2} {description2}
                    </Card.Text>
                  </div>
                  <Card.Text className="mt-2">{additionalInfo2}</Card.Text>
                  <div className="d-flex align-items-center w-100">
                    <Card.Text className="mt-3 d-flex align-items-center fw-bold gap-3 fs-three">
                      {descriptionIcon3}
                      {description3}
                    </Card.Text>
                  </div>
                  <Card.Text className="mt-2">{additionalInfo3}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="d-flex justify-content-center my-4">
          {/* <Button
            variant="none"
            as={Link}
            to=""
            className="more-btn purple-color fw-bold d-flex align-items-center border-0 py-2 px-3"
          >
            <img
              src="/assets/arrow-down.svg"
              alt="Play"
              className="fs-one me-2"
            />
            Load More
          </Button> */}
        </div>
      </Container>
    </div>
  );
};

export default Industries;
